module.exports = __webpack_public_path__ + "img/download_icon.13dcfcc6.svg";